export default "__VITE_ASSET__DPpPo4FC__"